import React from 'react';
import HeadLogo from "../Assets/Oolook_logo.webp";
import { Link } from 'react-router-dom';

export default function UnsubscribeError() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4 bg-neutral-light">
      <div className="auth-card text-center">
        <img src={HeadLogo} alt="Oolook Logo" className="mx-auto h-12 w-auto mb-6" />
        <div className="flex justify-center mb-6">
            <i className="fa-regular fa-circle-xmark text-5xl text-red-500"></i>
        </div>
        <h2 className="text-center text-2xl font-bold text-neutral-dark mb-2">Something Went Wrong</h2>
        <p className="text-center text-sm text-neutral-muted mb-8">
            We couldn't process your unsubscribe request at this time. Please try again later or contact our support team.
        </p>
        <Link to="/" className="btn-primary inline-block w-auto px-8">
          Back to Oolook
        </Link>
      </div>
    </div>
  );
}